import ExitToApp from "@mui/icons-material/ExitToApp";
import { Handle, type NodeProps, Position } from "@xyflow/react";

import type { AfterLastSentinelRuleNode } from "./loopTypes";
import LoopSentinelCard from "./LoopSentinelCard";

type AfterLastSentinelNodeProps = NodeProps<AfterLastSentinelRuleNode>;

const AfterLastSentinelNode = ({ selected }: AfterLastSentinelNodeProps) => (
	<LoopSentinelCard
		icon={<ExitToApp fontSize="small" />}
		accentColor="#7B61FF"
		gradId="coapp-grad-purple"
		label="Loop End"
		title="End"
		badge="Continues graph"
		description="Signals the end of the loop"
		selected={selected}
	>
		<Handle type="target" position={Position.Top} id="in" />
	</LoopSentinelCard>
);

export default AfterLastSentinelNode;
